import { Styles } from 'jss';

export default (theme: StyleTheme): Styles => ({
  disabled: {
    width: '100%',
    height: 230,
    backgroundColor: theme.palette.backgroundSecondary,
  },
});
